export const getCurrentModalIdSelector = state => state.modal.modalId;
export const getCurrentModalComponent = state => state.modal.modalProps.component;
export const getModalProps = state => state.modal.modalProps;
export const getForceCloseOnboarding = state => state.modal.forceCloseOnboarding;
export const getOnboardingSaveOnlyMode = state => state.modal.onboardingSaveOnlyMode;
export const getOnboardingActiveSlide = state => state.modal.onboardingActiveSlide;
